import React from "react";
import { Jumbotron as Jumbo, Container } from "react-bootstrap";

const Jumbotron = ({ pageName, message }) => {
  return (
    <div className="jumbo-container">
      <Jumbo fluid className="jumbo">
        <br />
        <br />
        <Container>
          <br />
          <br />
          <h1>{pageName}</h1>
          <p>{message}</p>
        </Container>
      </Jumbo>
    </div>
  );
};

export default Jumbotron;
